import React from 'react';
import Select from 'react-select';

const FilterModal = ({
    show,
    onClose,
    states,
    cities,
    salesManagers,
    selectedStates,
    selectedCities,
    selectedSalesManager,
    onStateChange,
    onCityChange,
    onSalesManagerChange,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    onApply,
    onReset,
    children
}) => {
    if (!show) return null;

    return (
        <>
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1040 }} onClick={onClose}></div>
            <div className="filter-dropdown">
                <div className="filter-dropdown-header">
                    <h6>Filter Options</h6>
                    <button type="button" className="filter-close-btn" onClick={onClose}>
                        <i className="mdi mdi-close"></i>
                    </button>
                </div>
                {states && (
                    <div className="filter-group">
                        <label>States</label>
                        <Select
                            isMulti
                            options={states}
                            value={selectedStates}
                            onChange={onStateChange}
                            placeholder="Select States"
                        />
                    </div>
                )}
                {cities && (
                    <div className="filter-group">
                        <label>Cities</label>
                        <Select
                            isMulti
                            options={cities}
                            value={selectedCities}
                            onChange={onCityChange}
                            placeholder="Select Cities"
                            isDisabled={selectedStates && selectedStates.length === 0}
                            className="cities-select"
                        />
                    </div>
                )}
                {salesManagers && (
                    <div className="filter-group">
                        <label>Sales Manager</label>
                        <Select
                            options={salesManagers}
                            value={selectedSalesManager}
                            onChange={onSalesManagerChange}
                            placeholder="Select Sales Manager"
                            isClearable
                        />
                    </div>
                )}
                {(onStartDateChange || onEndDateChange) && (
                    <div className="filter-date-row">
                        <div className="filter-group">
                            <label>Start Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDate || ''}
                                onChange={(e) => onStartDateChange && onStartDateChange(e.target.value)}
                            />
                        </div>
                        <div className="filter-group">
                            <label>End Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDate || ''}
                                onChange={(e) => onEndDateChange && onEndDateChange(e.target.value)}
                            />
                        </div>
                    </div>
                )}
                {children}
                <div className="filter-dropdown-footer">
                    <button type="button" className="btn btn-light btn-sm btn-rounded" onClick={onReset}>Reset</button>
                    <button type="button" className="btn btn-primary btn-sm" onClick={onApply}>Apply</button>
                </div>
            </div>
        </>
    );
};

export default FilterModal;
